import { useState, AnimationEvent } from 'react';

import * as styles from './useAutofillEvent.sty.js';

/**
 * returns the animationHandler that needs to be bound on the
 * native element to detect if it is autofilling and returns that state.
 */
export function useAutofillEvent() {
  const [isAutoFilled, setIsAutoFilled] = useState<boolean>(false);

  const onAnimationStart = (e: AnimationEvent<HTMLElement>) => {
    switch (e.animationName) {
      case styles.start:
        setIsAutoFilled(true);
        break;
      case styles.end:
        setIsAutoFilled(false);
        break;
    }
  };

  return { isAutoFilled, onAnimationStart };
}
